import React from "react";

const SubHeadingOne = props => {
  return <div className="subheading1">{props.text}</div>;
};

export default SubHeadingOne;
